// Owner 2026-10-19 (requirement 71, v2.11): import of opening stock + BOM. No imports (Jest).

export const STATUS_LABEL = { BARU: "Baru", DIUBAH: "Diubah", SAMA: "Sama", BERMASALAH: "Bermasalah" };

// v2.17.4: the column headers of the template ("Harga beli per satuan"), so Finance finds the column in the file
const FIELD = { nama: "Nama bahan", satuan: "Satuan", harga_beli: "Harga beli per satuan", stok_minimum_milli: "Stok minimum",
  mode_pakai: "Mode pakai", koefisien_milli: "Jumlah per pcs / m²", pos_pemakaian: "Pos pemakaian" };
export const labelField = (f) => FIELD[f] || f;

// 12500 -> "12,5" (quantities are kept as thousandths)
export function qty(milli) {
  if (milli == null) return "";
  const neg = milli < 0; const a = Math.abs(milli);
  const frac = a % 1000 ? `,${String(a % 1000).padStart(3, "0")}`.replace(/0+$/, "") : "";
  return `${neg ? "-" : ""}${Math.floor(a / 1000).toLocaleString("id-ID")}${frac}`;
}

export function nilai(f, v) {
  if (v == null || v === "") return "—";
  if (f === "stok_minimum_milli") return qty(v);
  if (f === "harga_beli") return `Rp${Number(v).toLocaleString("id-ID")}`;
  return String(v);
}

// Rows the apply will write, and the count per sheet (BERMASALAH and SAMA are never applied).
export function jumlahTerapkan(r) {
  if (!r) return 0;
  const n = (rows) => rows.filter((x) => x.status === "BARU" || x.status === "DIUBAH").length;
  return n(r.bahan || []) + n(r.bom || []);
}

export const saringBaris = (rows, status) => (status ? rows.filter((x) => x.status === status) : rows);
